export default {
	tabs: ["Insättning", "Historik"],
	History: {
		tabs: ["Granskning", "Lyckades", "Avvisa"]
	},
	AccountAmount: "Kontobelopp",
	ContactCustomerService: "Kontakta Kundtjänst",
	NoCustomerService: "Kundtjänst Upptagen",
	tips: "Vänligen lämna in den tidigare bedömningen innan du går vidare med nästa bedömning!"
};
